import { useState, useEffect } from "react";
import { useForm } from "react-hook-form";
import { FaCheck } from "react-icons/fa";
import { MdClose } from "react-icons/md";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { textLogo, reg_doodle, emailIcon } from "../../constant/import";
import { useStateGetter } from "../../hooks/statehooks/UseStateGettersHook";
import { useStateSetter } from "../../hooks/statehooks/UseStateSettersHook";
import { onGetOtp, onVerifyOtp, onVerifyAccount } from "../../services/auth/user";
import { OTPnumber } from "../auth/Number";
import { Button } from "../forms";

const VerifyOtp = (props:any) => {
    const { handleSubmit, control, watch } = useForm();
    const { isTabletOrMobile,authuser } = useStateGetter();
    const [enteredOTP, setEntered] = useState("");
    const watchedFields = watch(["email"]);
    const navigate = useNavigate();
    const { setLoading, showModal, setShowModal } = useStateSetter();
    const areFieldsFilled = watchedFields.every(
      (field) => field !== "" && field !== undefined
    );
   
  
   const resendOtp= async () => {
      setLoading(true);
      var postdata = { email: authuser.email };
      
      var res =await onGetOtp(postdata)
      setLoading(false);
      toast("OTP sent to your email")
    
      setShowModal(false);
    }
  
 
    const onSubmit = () => {};
  
    const OnVerifySuccess = () => (
      <div className="">
        <p className=" font-medium text-textbg  my-2">
          {" "}
     Verification Successsfuly{" "}
        </p>
        <div className=" gap-6 w-full flex ">
          <Button
            disabled={false}
            text="Login"
            onBtnClick={() => {
              navigate("/");
              setShowModal(false);
            }}
          />
        </div>{" "}
      </div>
    );
    const OnVerifyFailed = () => (
      <div className="">
        <p className=" font-medium text-textbg  my-2">
          {" "}
          Verification Failed{" "}
        </p>
        <div className=" gap-6 w-full flex ">
          <Button
            disabled={false}
            text="Ok"
            onBtnClick={() => {
             
              setShowModal(false);
            }}
          />
        </div>{" "}
      </div>
    );
    const submitemailOTP = async () => {
      var postdata = {
        email: authuser.email,
        otp: enteredOTP,
      };
  
  
      try{
  
      
      setLoading(true);
  
      var res = await onVerifyOtp(postdata);
      setLoading(false);
    
      if (res.success) {
     
navigate('/home/settings/resetpassword')      
}
      
    }
      catch(error:any){
         
        showModal(
          error,
          "",
          <MdClose
            size={30}
            className="inline  text-red-400 bg-green-200 p-2 rounded-full"
          />,
          <OnVerifyFailed />
        );
        setLoading(false)
      }
  
      console.log(enteredOTP);
    };
  
    return (
        
        <div className="bg-white  w-[100%] md:w-[50%] p-6  mt-6   md:mx-20 md:py-2 md:px-20 shadow flex flex-col  justify-center items-center">
          <img src={emailIcon} className="w-[55px] my-6" />
  
          <p className="font-bold text-textbg text-[24px] text-center ">
            Verify Your Email
          </p>
          <small className="font-light text-textbg text-xs text-center ">
            kindly enter the code sent to your email to complete the process{" "}
          </small>
          <div className=" my-4">
            <OTPnumber setEntered={setEntered} />
  
            <Button
              disabled={!(enteredOTP.length == 4)}
              text="Verify"
              onBtnClick={handleSubmit(submitemailOTP)}
            />
  
            <div className="flex justify-center items-center">
              <small className="font-medium text-textbg text-xs ">
                Didn't get code?
                <p className="text-primary inline" onClick={resendOtp}>
                  Resend 
                </p>
              </small>
            </div>
  
   
          </div>
        </div>
     );
  };

  export{VerifyOtp}